export default __webpack_public_path__ + "static/climate2-3ebad3015cc9b6dff1349425af21e420.png";